import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  useDisclosure,
  Input,
} from "@heroui/react";
import { useCallback, useState } from "react";
import { api } from "@/api";
import { toast } from "react-toastify";
import useErrorHandling from "@/hooks/useErrorHandling";

export function TransferOwnershipModal({
  disclosure,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
}) {
  const [username, setUsername] = useState<string>("");
  const handleError = useErrorHandling();

  const transfer = useCallback(() => {
    api.businessProfiles
      .transferOwnership(username)
      .then(() => {
        toast.success("Профиль успешно передан!");
        location.href = "/dashboard/selectProfile";
      })
      .catch((err) => {
        const { errorMessage } = handleError(err);
        toast.error(errorMessage);
      });
  }, [handleError, username]);

  return (
    <Modal
      isOpen={disclosure.isOpen}
      onOpenChange={disclosure.onOpenChange}
      portalContainer={document.getElementById("main")!}
      backdrop="blur"
      scrollBehavior="outside"
    >
      <ModalContent>
        {() => (
          <>
            <ModalHeader>
              <span>Передача владения бизнес-профилем</span>
            </ModalHeader>
            <ModalBody>
              <div className="flex flex-col gap-4">
                <span>
                  Вы собираетесь передать права владения вашим бизнесом
                </span>
                <span>
                  Эту операцию невозможно отменить - в случае ошибки вам
                  придётся связываться с технической поддержкой
                </span>
                <span>
                  Введите логин пользователя, которому хотите передать права:
                </span>
                <Input
                  placeholder="Введите логин пользователя"
                  variant="bordered"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>
            </ModalBody>
            <ModalFooter>
              <div className="w-full flex flex-row gap-2">
                <Button
                  color="primary"
                  variant="flat"
                  className="w-full"
                  onPress={transfer}
                  isDisabled={!username}
                >
                  Подтвердить передачу
                </Button>
              </div>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
}
